import apiClient from "config/api";

const getAdminNotifications = async (options) => {
  return apiClient.get("/admin/notifications", { params: options });
};

const markReadAdminNotification = async (payload) => {
  return apiClient.put("/admin/notifications/mark-read", payload);
};

const markAllReadAdminNotifications = async () => {
  return apiClient.put(`/admin/notifications/mark-read-all`);
};

export {
  getAdminNotifications,
  markReadAdminNotification,
  markAllReadAdminNotifications,
};
